import {Dispatch} from "react";
import {TCarouselActions} from "../actions/carouselActions";

export const changeCarouselActiveSlide = (page: number) => {
    return async (dispatch: Dispatch<TCarouselActions>) => {
        dispatch({
            type: "CHANGE_CAROUSEL_ACTIVE_SLIDE",
            page,
        });
    };
};
